jQuery(document).ready(function($){



  // var assets = {};
  // assets['Size'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-size_1024x1024.png?v=31543344121325044601766487755';
  // assets['Headboard Height'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-headboard-height_1024x1024.png?v=71651354222714580451766487755';
  // assets['Fabric'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-fabric_1024x1024.png?v=32846084406414885621766487755';
  // assets['Ottoman Gas Lift Storage'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271766487755';
  // assets['Storage Option'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271766487755';
  // assets['Ottoman Storage'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271766487755';
  // assets['Studs'] = '//www.bedchoices.co.uk/cdn/shop/t/25/assets/icon-stud_1024x1024.png?v=86582165931147821201766487755';
  
  // let checkCount = 0;
  // const maxChecks = 20; // Stop after 20 checks
  // const interval = setInterval(function () {
  //     const element = $('#infiniteoptions-container');
  //     if (element.length) {
  //         console.log('#infiniteoptions-container exists!');
  //         setTimeout(function(){
  //             castleProductImprovement();
  //         },1500);
  //         clearInterval(interval); // Stop checking once the element is found
  //     } else {
  //         checkCount++;
  //         if (checkCount >= maxChecks) {
  //             console.log('Element not found after 20 checks.');
  //             clearInterval(interval); // Stop checking after maxChecks
  //         }
  //     }
  // }, 1000); 


  // if ($('.infiniteoptions-price').length){
  //   $('.infiniteoptions-price').appendTo('.product__add__cart__button button');
  // }

  
  // function castleProductImprovement(){

  
      
  //     $('.castle-options-selector').remove();

  //     var selectorHTML = '';
  //     selectorHTML+='<div class="castle-options-selector">';
    
  //     $('#infiniteoptions-container').children('div').each(function() {
          
  
  //         if ($(this).attr('disabled')  || $(this).hasClass('color_cover')){
  //             console.log('Skip this div');
  //         } else {
  //             var selectorName = $(this).find('.spb-label-tooltip > label').html();

                            
  //               console.log('spb-productdescfont', $(this).find('.spb-label-tooltip > label').html());
  
  //               var imageURL = 'https://dummyimage.com/50x50/000/fff';
  //               if (assets.hasOwnProperty(selectorName) && assets[selectorName]) {

  //                 $(this).addClass('castle-option').attr('data-castle-option',selectorName);
  //                 imageURL = assets[selectorName];
  //                 var selectorButtonHTML = '';
  //                 selectorButtonHTML+='<img title="' + selectorName + '" alt="' + selectorName + '" src="' + imageURL + '" class="img-fluid"/>';
  //                 selectorButtonHTML+='<label>' + selectorName + '</label>';
      
  //                 selectorHTML+='<div class="castle-target" data-target="' + selectorName + '" class="caste-option">' + selectorButtonHTML + '</div>';
  //               }else{

  //                 if (typeof(selectorName) != 'undefined'){
  //                   $(this).addClass('castle-option').attr('data-castle-option',selectorName);
  //                   var selectorButtonHTML = '';
  //                   selectorButtonHTML+='<img title="' + selectorName + '" alt="' + selectorName + '" src="' + imageURL + '" class="img-fluid"/>';
  //                   selectorButtonHTML+='<label>' + selectorName + '</label>';
  //                   selectorHTML+='<div class="castle-target" data-target="' + selectorName + '" class="caste-option">' + selectorButtonHTML + '</div>';
  //                 }
                  
                  
  //               }
    
                
  //         }
  
          
  //     });

  //     $('.spb-productoptionswatchwrapper').each(function() {
  //       var label = $(this).find('.spb-swatchlabel').html();
  //       var image = $(this).find('.spb-productoptionswatch').attr('data-image',label);
  //     });
  
  
  //     $(document).on('click','.castle-options-selector .castle-target',function(){
  //         $('.castle-option').removeClass('castle-active');
  //         var selector = $(this).attr('data-target');
  //         $('.castle-option[data-castle-option="' +selector+'"]').addClass('castle-active');
          
  //         $('.castle-options-selector > div').removeClass('active');
  //         $(this).addClass('active');

  //         $('.color_cover').css('opacity',0).hide();
  //         // $('select.spb-productdescfont').val('').trigger('change');
        
  //     });
  
  //     selectorHTML+='</div>';
  //     $('#infiniteoptions-container').before(selectorHTML);
  //     $('.castle-target').first().addClass('active').trigger('click');

  //     $('.castle-options-selector').addClass('castle-options-count-' + $('.castle-target').length);
  //   }



  // $('.add-to-basket-btn').on('click', function () {
  //   var $btn = $(this);
  //   var variantId = $btn.data('variant-id');

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: {
  //       quantity: 1,
  //       id: variantId
  //     },
  //     dataType: 'json',
  //     beforeSend: function () {
  //       $btn.prop('disabled', true);
  //       $btn.find('.action__btn--text--label').text('Adding...');
  //     },
  //     success: function () {
  //       $btn.find('.action__btn--text--label').text('Added!');
  //       document.dispatchEvent(new Event('open-mini-cart'));
  //       // Optional: trigger cart drawer or refresh cart icon
  //     },
  //     error: function () {
  //       $btn.find('.action__btn--text--label').text('Error');
  //     },
  //     complete: function () {
  //       setTimeout(function () {
  //         $btn.prop('disabled', false);
  //         $btn.find('.action__btn--text--label').text('ADD TO BASKET');

          
          
  //       }, 2000);

        
  //     }
  //   });
  // });


  $('.add-to-basket-btn').on('click', function () {
  const $btn = $(this);
  const variantId = $btn.data('variant-id');

  const submitButton = $btn.get(0); // raw DOM element
  submitButton.setAttribute('disabled', true);
  $btn.find('.action__btn--text--label').text('Adding...');
  submitButton.classList.add('loading');

  const cartNotification = document.querySelector('cart-notification');
  const cartItems = document.querySelector('cart-items');
  const quickViewWrapper = document.getElementById('quickViewWrapper');

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  if (cartNotification) {
    formData.append(
      'sections',
      cartNotification.getSectionsToRender().map((section) => section.id)
    );
    cartNotification.setActiveElement(document.activeElement);
  }

  if (cartItems) {
    formData.append(
      'sections',
      cartItems.getSectionsToRender().map((section) => section.section)
    );
  }

  formData.append('sections_url', window.location.pathname);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((parsedState) => {
      if (parsedState.status) {
        console.error('Cart error:', parsedState.description);
        $btn.find('.action__btn--text--label').text('Error');
        return;
      }

      if (cartNotification) {
        cartNotification.renderContents(parsedState);
      }

      if (cartItems) {
        cartItems.renderContents(parsedState);
      }

      $btn.find('.action__btn--text--label').text('Added!');
    })
    .catch((e) => {
      console.error(e);
      $btn.find('.action__btn--text--label').text('Error');
    })
    .finally(() => {
      setTimeout(() => {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        $btn.find('.action__btn--text--label').text('ADD TO CART');

        quickViewWrapper?.classList.remove('show__modal');
        document.body.classList.remove('overflow-hidden');

        $('.add_on_products_cover .related-product-list').hide();
      }, 2000);
    });
});


  

    $(document).on('click','.btn-select-mattress',function(){
      $('.add_on_products_cover .related-product-list').slideToggle();
    });



//  function moveCastleVariant() {
//     var $mediaGallery = $('.product__media_container ');
//     var $castleOptions = $('#castle-variant-options');
//     var $productTax = $('.product__tax');
  
//     if ($(window).width() <= 768) {
  
//       $mediaGallery.append($castleOptions);
//     } else {
//       $productTax.before($castleOptions);
//     }
//   }

// $(document).ready(function() {
//   moveCastleVariant(); // call on page load

//   $(window).resize(function() {
//     moveCastleVariant(); // call on window resize
//   });
// });


  

  
});